import { BehaviorSubject } from "rxjs";
import device from "current-device";
import { t } from "i18next";
import variables from "css/_variables.scss";

// laderStatus as Subject, It will work as both observer and obserable
export const loaderStatus = new BehaviorSubject(true);
export const CAROUSEL_RESPONSIVE_IMAGE = device.tablet() ? 4 : 2;
export const SQUARE_RESPONSIVE_IMAGE = device.tablet() ? 6 : 4;

// Editor Primary color
export const editor_primary_color = variables.editorPrimary;

export const isPortrait = () =>
  window.matchMedia("(orientation: portrait)").matches;

export const isLandscape = () =>
  window.matchMedia("(orientation: landscape)").matches;

export const stopEvents = (ev) => {
  ev.preventDefault();
  ev.stopPropagation();
  ev.nativeEvent.stopImmediatePropagation();
};

export const replaceSpecialChars = (str) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .trim() // Trim whitespace from ends
    .replace(/([^\w]+|\s+)/g, "-"); // Replace space and other characters by hyphen

export const reorderRankedItems = (list, startIndex, endIndex) => {
  if (endIndex < 0) endIndex = 0;
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result.map((it, idx) => {
    it.rank = idx + 1;
    return it;
  });
};

export const mergeArrays = (arr1, arr2) => {
  // Best friends forever: https://stackoverflow.com/questions/47554688/es6-merge-two-array-of-objects-and-override-the-existing-object
  const result = Object.values(
    [...arr1, ...arr2].reduce((result, { uuid, ...rest }) => {
      result[uuid] = {
        ...(result[uuid] || {}),
        uuid,
        ...rest,
      };
      return result;
    }, {}),
  );

  return result;
};

export const mergeObjectsInArrays = (arr1, arr2) => {
  const result = arr2.reduce((result, selected) => {
    arr1.forEach((item) => {
      if (item.uuid === selected.uuid) {
        result.push(item);
      }
    });
    return result;
  }, []);

  return mergeArrays(arr2, result);
};

/**
 * Return multiple formated duration value
 * @param {number} duration in seconds
 * @returns {{
 *  string: {
 *    seconds: string;
 *    minutes: string;
 *    hours: string;
 *    days: string;
 *    full: string;
 *  };
 *  number: {
 *    seconds: number;
 *    minutes: number;
 *    hours: number;
 *    days: number;
 *  };
 *  humanised: string;
 * }} string, number and humanised version of the duration
 */

export const prettyDuration = (
  duration,
  { format } = {
    format: { noDays: false },
  },
) => {
  if (
    duration === null ||
    isNaN(Number(duration)) ||
    duration === Infinity ||
    duration === -Infinity
  )
    return;

  const seconds = duration;
  const minutes = Math.floor(duration / 60);
  const hours = Math.floor(duration / 3600);
  const days = Math.floor(duration / 60 / 60 / 24);

  const secondsMod = seconds % 60;
  const minutesMod = minutes % 60;
  const hoursMod = hours % 24;

  const secondsString = `${seconds}${t("editor-utils:secondUnit")}`;
  const minutesString =
    minutes >= 1 ? `${minutes}${t("editor-utils:minuteUnit")}` : "";
  const hoursString = hours >= 1 ? `${hours}${t("editor-utils:hourUnit")}` : "";
  const daysString = days >= 1 ? `${days}${t("editor-utils:dayUnit")}` : "";

  const secondsStringMod =
    secondsMod >= 1 ? `${secondsMod}${t("editor-utils:secondUnit")}` : "";
  const minutesStringMod =
    minutesMod >= 1 ? `${minutesMod}${t("editor-utils:minuteUnit")}` : "";
  const hoursStringMod =
    hoursMod >= 1 ? `${hoursMod}${t("editor-utils:hourUnit")}` : "";

  const humanised = `${
    format.noDays ? hoursString : `${daysString} ${hoursStringMod}`
  } ${minutesStringMod} ${secondsStringMod}`
    .replace(/\s+/g, " ") // keep only one space between words
    .trim();

  return {
    humanised,
    string: {
      seconds: secondsString,
      minutes: minutesString,
      hours: hoursString,
      days: daysString,
    },
    number: {
      seconds,
      minutes,
      hours,
      days,
    },
  };
};
